export default __webpack_public_path__ + "static/media/right-arrow.7df73be7.svg";